class LoggerService {
  static LOG_LEVELS = {
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR"
  };

  static MODULE = {
    STREAMING: "STREAMING"
  };

  static MODULE_CONFIG = {
    STREAMING: true,
    NONE: false
  };

  static MODULE_LABELS = {
    STREAMING: "ST"
  };

  static LOG_LEVELS_CONFIG = {
    DEBUG: false,
    INFO: false,
    WARNING: false,
    ERROR: false
  };

  static enableLogging(config) {
    if (typeof config == "object") {
      LoggerService.LOG_LEVELS_CONFIG = config.logLevels;
      LoggerService.MODULE_CONFIG = { ...config.modules, NONE: false };
    } else {
      LoggerService.LOG_LEVELS_CONFIG = {
        DEBUG: true,
        INFO: true,
        WARNING: true,
        ERROR: true
      };
      LoggerService.MODULE_CONFIG = {
        STREAMING: true,
        NONE: false
      };
    }
  }

  static log(
    module = LoggerService.MODULE.NONE,
    message,
    logLevel = LoggerService.LOG_LEVsELS.DEBUG,
    error
  ) {
    let moduleLogsEnabled = LoggerService.MODULE_CONFIG[module];

    if (moduleLogsEnabled) {
      const moduleLabel = LoggerService.MODULE_LABELS[module];
      const logTimestamp = new Date().toLocaleTimeString();

      if (logLevel == LoggerService.LOG_LEVELS.ERROR) {
        console.log(`[${logLevel}] [${logTimestamp}] [${moduleLabel}] ${message}`);
        console.error(error);
      } else {
        console.log(`[${logLevel}] [${logTimestamp}] [${moduleLabel}] ${message}`);
      }
    }
  }

  static debug(module, message) {
    if (LoggerService.LOG_LEVELS_CONFIG.DEBUG) {
      LoggerService.log(module, message, LoggerService.LOG_LEVELS.DEBUG);
    }
  }

  static info(module, message) {
    if (LoggerService.LOG_LEVELS_CONFIG.INFO) {
      LoggerService.log(module, message, LoggerService.LOG_LEVELS.INFO);
    }
  }

  static warning(module, message) {
    if (LoggerService.LOG_LEVELS_CONFIG.WARNING) {
      LoggerService.log(module, message, LoggerService.LOG_LEVELS.WARNING);
    }
  }

  static error(module, message, error) {
    if (LoggerService.LOG_LEVELS_CONFIG.ERROR) {
      LoggerService.log(
        module,
        `${message} ${error && error.message}`,
        LoggerService.LOG_LEVELS.ERROR,
        error
      );
    }
  }

  static table(module, object) {
    let moduleLogsEnabled = LoggerService.MODULE_CONFIG[module];

    if (moduleLogsEnabled) {
      console.table(object);
    }
  }
}

// Export the logger service
export default LoggerService;
